/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { equalScalarDependencies } from './dependenciesEqualScalar.generated';
import { matrixDependencies } from './dependenciesMatrix.generated';
import { multiplyScalarDependencies } from './dependenciesMultiplyScalar.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createDotMultiply } from '../../factoriesAny.js';
export var dotMultiplyDependencies = {
  equalScalarDependencies: equalScalarDependencies,
  matrixDependencies: matrixDependencies,
  multiplyScalarDependencies: multiplyScalarDependencies,
  typedDependencies: typedDependencies,
  createDotMultiply: createDotMultiply
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesDotMultiply.generated.js
// module id = 1393
// module chunks = 0